import { render, staticRenderFns } from "./CreateTemplate.vue?vue&type=template&id=87b0933c&scoped=true&"
import script from "./CreateTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CreateTemplate.vue?vue&type=style&index=0&id=87b0933c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b0933c",
  null
  
)

export default component.exports